import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';
import { useToastStore } from '@/store/useToast';

export const ToastContainer = () => {
  const { toasts, removeToast } = useToastStore();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] flex flex-col gap-2 w-[90vw] max-w-sm pointer-events-none">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`flex items-center gap-3 px-4 py-3 rounded-xl shadow-lg text-white pointer-events-auto ${
            t.type === 'success'
              ? 'bg-green-500'
              : t.type === 'error'
              ? 'bg-red-500'
              : 'bg-blue-500'
          }`}
        >
          {t.type === 'success' && <CheckCircle size={18} className="flex-shrink-0" />}
          {t.type === 'error' && <AlertCircle size={18} className="flex-shrink-0" />}
          {t.type === 'info' && <Info size={18} className="flex-shrink-0" />}
          <p className="text-sm font-medium flex-1">{t.message}</p>
          <button
            onClick={() => removeToast(t.id)}
            className="flex-shrink-0 hover:opacity-70 transition-opacity"
          >
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  );
};
